<template>
  <v-container fluid class="tp-page">
    <!-- Cabeçalho -->
    <div class="tp-page-head">
      <div>
        <h1 class="tp-page-title">Associar QR Code</h1>
        <p class="tp-page-sub">{{ associacoes.length }} no total</p>
      </div>
      <div class="tp-head-actions">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" placeholder="Buscar…" hide-details dense outlined color="#00695C" class="tp-search"></v-text-field>
        <v-btn color="#00695C" dark depressed rounded class="tp-btn-add" @click="carregaAssociacoes">
          <v-icon left>sync</v-icon>Recarregar
        </v-btn>
      </div>
    </div>

    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-select outlined dense v-model="eventoId" :items="eventos" item-text="nome" item-value="id" label="Selecione o Evento" @input="carregaAssociacoes()" color="#00695C"></v-select>
      </v-col>
    </v-row>

    <!-- Tabela -->
    <v-card class="tp-card" elevation="0">
      <v-data-table :search="search" :headers="headers" :items="associacoes" sort-by="nome">
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small color="#00695C" @click="realizarCheckin(item)" v-bind="attrs" v-on="on">check_circle</v-icon>
            </template>
            <span>Associar</span>
          </v-tooltip>
        </template>
        <template slot="no-data">
          <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Nenhuma convocação aprovada para este evento</v-alert>
        </template>
        <template slot="no-results">
          <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Sua pesquisa por "{{search}}" não trouxe resultados</v-alert>
        </template>
      </v-data-table>
    </v-card>

    <!-- DIÁLOGO PARA REALIZAR CHECK-IN -->
    <v-dialog v-model="dialogoCheckin" persistent max-width="350px">
      <v-card class="tp-card" elevation="0">
        <v-card-title style="justify-content: center; padding: 8px;">
          <span class="tp-serif" style="font-size:1.15rem;color:#00253E;font-weight:600;margin-bottom: -23px">REALIZAR ASSOCIAÇÃO</span>
        </v-card-title>
        <v-card-text v-if="!validacao" style="text-align: center;padding: 0px 5px 0px">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="6" md="12" v-if="dialogoCheckin">
                <qrcode-stream @decode="onDecode"></qrcode-stream>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text v-if="validacao" style="text-align: center;padding: 0px 5px 0px;">
          <v-container>
            <br>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                <p class="tp-serif" :style="`color:${corValidacao}`">{{msgValidacao}}</p>
              </v-col>
              <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                <v-icon large :color="corValidacao">{{iconValidacao}}</v-icon>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions v-if="!validacao" style="margin-top: -32px;padding: 20px 5px 0px;">
          <v-container fluid grid-list-md>
            <v-layout row wrap justify-center>
              <v-flex xs6 sm6 lg6>
                <v-btn dark depressed block color="error" style="border-radius: 7px;" large @click="dialogoCheckin = false">Fechar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
        <v-card-actions v-if="validacao" style="margin-top: -32px;padding: 20px 5px 0px;">
          <v-container fluid grid-list-md>
            <v-layout row wrap justify-center>
              <v-flex xs12 sm12 lg12>
                <v-btn dark depressed block color="#00695C" style="border-radius: 7px;" large @click="dialogoCheckin = false">Continuar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIM DO DIÁLOGO PARA REALIZAR CHECK-IN -->

    <!-- DIÁLOGO PARA CRIAR A SENHA DO VIGILANTE -->
    <v-dialog v-model="senhaVigilante" persistent max-width="350px">
      <v-card class="tp-card" elevation="0">
        <v-card-title style="justify-content: center; padding: 8px;">
          <span class="tp-serif" style="font-size:1.15rem;color:#00253E;font-weight:600">CRIAR SENHA</span>
        </v-card-title>
        <v-card-text style="text-align: center;padding: 0px 0px 0px;">
          <v-container>
            <v-row align="center" justify="center">
              <v-flex xs10 sm10 md10 lg10 v-if="urlBase != 'https://aipass.intelite.com.br/api/'">
                <vueAnkaCropper
                  v-if="arquivoFotoPessoal == ''"
                  :options="{
                    aspectRatio: 1,
                    closeOnSave: true,
                    cropArea: 'box',
                    croppedHeight: 500,
                    croppedWidth: 500,
                    cropperHeight: false,
                    dropareaMessage: 'Tire uma foto pessoal do rosto do vigilante',
                    frameLineDash: [0,0],
                    frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
                    handleFillColor: 'rgba(255, 255, 255, 0.2)',
                    handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
                    handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
                    handleSize: 10,
                    handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
                    layoutBreakpoint: 500,
                    maxCropperHeight: 768,
                    maxFileSize: 8000000,
                    overlayFill: 'rgba(0, 0, 0, 0.5)',
                    previewOnDrag: false,
                    previewQuality: 0.65,
                    resultQuality: 0.9,
                    resultMimeType: 'image/jpeg',
                    selectButtonLabel: 'Escolher imagem',
                    showPreview: false,
                    skin: 'light',
                    uploadData: {},
                    uploadTo: false
                  }"
                  @cropper-error="erroCorte($event)"
                  @cropper-saved="salvarCorte($event)"
                  @cropper-cancelled="cancelaCorte()"
                ></vueAnkaCropper>
                <img v-else width="160px" :src="arquivoFotoPessoal" alt="FotoPessoal" />
                <br>
              </v-flex>
              <v-flex xs10 sm10 md10 lg10>
                <v-alert dark dense :value="true" color="warning" icon="info">Solicite a criação de uma senha 4 dígitos numéricos.</v-alert>
              </v-flex>
              <v-flex xs10 sm10 md10 lg7>
                <v-text-field
                  v-model="senhaInformada"
                  label="Senha"
                  dense
                  outlined
                  type="tel"
                  :rules="[rules.max, rules.min]"
                ></v-text-field>
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions style="margin-top: -40px;padding: 20px 5px 0px;">
          <v-container fluid grid-list-md>
            <v-layout row wrap justify-center>
              <v-flex xs12 sm6 lg6>
                <v-btn dark depressed block color="#00695C" style="border-radius: 7px;" @click="salvarSenha">Salvar Senha</v-btn>
              </v-flex>
              <v-flex xs12 sm6 lg6>
                <v-btn dark depressed block color="error" style="border-radius: 7px;" @click="senhaVigilante = false">Fechar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIM DO DIÁLOGO PARA CRIAR A SENHA DO VIGILANTE -->
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import moment from 'moment'
  import axios from 'axios'
  import vueAnkaCropper from 'vue-anka-cropper'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading, vueAnkaCropper },
    data: () => ({
      eventoId: '',
      eventoIdAtual: '',
      fullPage: true,
      isLoading: false,
      loading: false,
      search: '',
      nome: '',
      headers: [
        { text: 'Nome', align: 'start', value: 'nome' },
        { text: 'CPF', value: 'cpf' },
        { text: 'Sexo', value: 'sexo' },
        { text: 'Telefone', value: 'telefone' },
        { text: 'E-mail', value: 'email' },
        { text: 'Qualificação', value: 'qualificacao' },
        { text: 'Status', value: 'status' },
        { text: 'Realizada em', value: 'created' },
        { text: 'Ações', value: 'action', align: 'center', sortable: true }
      ],
      editedIndex: -1,
      eventos: [],
      vigilantes: [],
      associacoes: [],
      dialogoCheckin: false,
      audio: '',
      tipo: '1',
      validacao: false,
      msgValidacao: '',
      iconValidacao: '',
      corValidacao: '',
      codigoQrCode: '',
      senhaVigilante: false,
      senhaInformada: '',
      exibeSenha: false,
      idQrCode: '',
      idAssociacao: '',
      idVigilante: '',
      urlBase: '',
      arquivoFotoPessoal: '',
      rules: {
        max: v => v.length <= 4 || 'Máximo de 4 dígitos',
        min: v => v.length >= 4 || 'Mínimo de 4 dígitos'
      },
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle() {
        return this.editedIndex === -1 ? 'ADICIONAR VIGILANTE' : 'EDITAR VIGILANTE'
      }
    }),

    mounted() {
      this.urlBase = baseApiUrl
      this.carregaEventos()
      this.audio = new Audio(require("../assets/beep.mp3"))
    },

    methods: {
      async carregaEventos() {
        this.isLoading = true
        await axios.get(`${baseApiUrl}Eventos?filter={"where":{"empresaId":"${this.companyobj.id}"}, "order":"inicio DESC"}&access_token=${sessionStorage.getItem('accToken')}`).then(res => {
          if (res.data != '') {
            for (var key in res.data) {
              if (res.data.hasOwnProperty(key)) {
                this.eventos.push(res.data[key])
              }
            }
            this.eventos = this.eventos.sort(this.compare)
            this.eventoId = this.eventos[0].id
            if (this.eventoIdAtual != '')
              this.eventoId = this.eventoIdAtual
          } else
            this.isLoading = false
        })
        await this.carregaAssociacoes()
      },

      async carregaAssociacoes() {
        this.isLoading = true
        try {
          this.associacoes = []
          await axios.post(`${baseApiUrl}AssociacoesEvento/listaConvocacao?access_token=${sessionStorage.getItem('accToken')}`, {"eventoId": this.eventoId}).then(response => {
            if (response.data) {
              for (let i = 0; i < response.data.length; i++) {
                if (response.data[i].status == 'APROVADO') {
                  this.associacoes.push({
                  'nome': response.data[i].nome,
                  'cpf': response.data[i].cpf,
                  'sexo': response.data[i].sexo,
                  'telefone': response.data[i].telefone,
                  'email': response.data[i].email,
                  'qualificacao': response.data[i].qualificacao,
                  'status': response.data[i].status,
                  'created': response.data[i].created,
                  'id': response.data[i].id,
                  'idVigilante': response.data[i].vigilanteId
                });
                }
              }
            }
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao buscar associações, tente novamente", "DESCULPE")
        }
      },

      compare(a) {
        // Use toUpperCase() to ignore character casing
        const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
        //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
        const dataC = moment().format()

        let comparison = 0;
        if (dataC >= dataA)
          comparison = 1;
        /* else
          if (dataA >= dataC && dataB < dataA)
            comparison = -1; */
        else
        if (dataC < dataA)
          comparison = -1;
        return comparison;
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateHour(data_hora) {
        let data = data_hora.substr(0, 10).split('-')
        data = data[2] + '/' + data[1] + '/' + data[0]
        let hora = data_hora.substr(11, 8)

        return data + ' ' + hora

      },

      formatDateBrz(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePadrao(date) {
        if (!date) return null

        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      async deleteItem(item) {
        var r = confirm('Deseja realmente excluir a solicitação de convocação de ' + item.nome + '?')
        if (r == true) {
          this.isLoading = true
          try {
            await axios.get(`${baseApiUrl}AssociacoesEvento/${item.id}?access_token=${sessionStorage.getItem('accToken')}`).then(response => {
              if (response.data.checkin) {
                axios.delete(`${baseApiUrl}AssociacoesEvento/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
                .then(() => {
                  var vm = this
                  vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
                  this.eventoIdAtual = this.eventoId
                  this.carregaAssociacoes()
                }).catch(() => {
                  this.isLoading = false
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
                })
              } else {
                this.isLoading = false
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#D1A102", "Não foi possível excluir, esta associação possui check-in realizado", "ATENÇÃO")
              }
            })
          } catch (error) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          }
        }
      },

      realizarCheckin(item) {
        this.idAssociacao = item.id
        this.idVigilante = item.idVigilante
        this.audio.play()
        this.dialogoCheckin = true
      },

      onDecode(decodedString) {
        this.codigoQrCode = decodedString
        this.audio.play()
        this.verificaQrCode()
      },

      async verificaQrCode() {
        if (this.codigoQrCode != '') {
          this.isLoading = true
          try {
            await axios.get(`${baseApiUrl}QRCodes?filter={"where":{"qrcode":"${this.codigoQrCode}"}}&access_token=${sessionStorage.getItem('accToken')}`).then(response => {
              if (response.data) {
                if (response.data[0].situacao == 'LIVRE') {
                  // solicita criação da senha ao vigilante (quatro digitos numéricos)
                  this.idQrCode = response.data[0].id
                  this.dialogoCheckin = false
                  this.senhaVigilante = true
                  this.isLoading = false
                } else {
                  this.dialogoCheckin = false
                  this.isLoading = false
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350", "Este QR Code já está em uso por outro vigilante!", "ERRO")
                }
              }
            })
          } catch (error) {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "QR Code não localizado!", "ERRO")
          }
        }
      },

      async salvarSenha() {
        var vm = this;
        if (this.urlBase != baseApiUrl) {
          if (this.arquivoFotoPessoal == '') {
            vm.$refs.chamaSnackbar.snack("#D1A102", "Foto do vigilante não selecionada!", "ATENÇÃO")
          }
        }
        if (this.senhaInformada.length > 4 || this.senhaInformada.length < 4) {
          vm.$refs.chamaSnackbar.snack("#D1A102", "A senha precisa ter 4 dígitos numéricos!", "ATENÇÃO")
        } else {
          this.isLoading = true
          try {
            // patch em QRCodes mudando a situação para "OCUPADO" e passando o atributo senha para salvar no qrCode
            await axios.patch(`${baseApiUrl}QRCodes/${this.idQrCode}?access_token=${sessionStorage.getItem('accToken')}`, {"situacao":"OCUPADO", "senha": this.senhaInformada}).then(response => {
              if (response.data) {
                if (this.urlBase != 'https://aipass.intelite.com.br/api/') {
                  this.salvaAnexo()
                }
                this.atualizaVigilante()
                this.atualizaAssociacao()
              }
            })
          } catch (error) {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao salvar a senha. Tente novamente", "DESCULPE")
          }
        }
      },

      async atualizaVigilante() {
        // patch no Vigilante passando o atributo qrCodeID
        try {
          await axios.patch(`${baseApiUrl}Vigilantes/${this.idVigilante}?access_token=${sessionStorage.getItem('accToken')}`, {"qrcodeId": this.idQrCode})
          .then(() => {
            // mostra mensagem de confirmação do checkin
            this.senhaVigilante = false
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1", "QR Code associado com sucesso!", "INFORMAÇÃO")
          }).catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao associar o QR Code. Tente novamente!", "DESCULPE")
          })
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao associar o QR Code. Tente novamente.", "DESCULPE")
        }
      },

      async atualizaAssociacao() {
        try {
          await axios.patch(`${baseApiUrl}AssociacoesEvento/${this.idAssociacao}?access_token=${sessionStorage.getItem('accToken')}`, {"qrcodeId": this.idQrCode})
        } catch (error) {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao atualizar a associação. Tente novamente.", "DESCULPE")
        }
      },

      async salvaAnexo() {
        try {
          await axios.post(`${baseApiUrl}ImagesDocs?access_token=${sessionStorage.getItem('accToken')}`, {"arquivoFotoPessoal": this.arquivoFotoPessoal, "vigilanteId": this.idVigilante})
        } catch (error) {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao atualizar a associação. Tente novamente.", "DESCULPE")
        }
      },

      async salvarCorte(event) {
        this.isLoading = true
        this.arquivoFotoPessoal = event.croppedImageURI
        this.isLoading = false
      },

      erroCorte (event) {
        if (event.substring(0,5) == "Wrong") {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Apenas imagens são permitidas!","ATENÇÃO");
        }
        else if (event.substring(0,4) == "File") {
          vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Arquivo muito grande. Máximo permitido de 8MB","ATENÇÃO");
        }
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 120px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>